import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  place-items: center;
  margin-bottom: 6rem;
`;

export const Header = styled.header`
  width: 100%;
  height: 34px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h4 {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
  }

  .MuiIconButton-root {
    padding: 6px;
  }

  .MuiSvgIcon-root {
    font-size: 22px;
  }
`;

export const DialogWrapper = styled.div`
  width: 560px;
  display: grid;
  padding: 0 28px;
  grid-gap: 5px;

  p {
    margin: 0;
    font-size: 15px;
    line-height: 24px;
  }

  .MuiFormControl-root {
    width: 100%;
  }
`;

export const RejectDialogWrapper = styled.div<{ error: boolean }>`
  width: 560px;
  display: grid;
  margin: 0 5px;
  padding: 0 20px 20px;
  white-space: pre-line;
  border: ${({ theme, error }) =>
  error ? `1px solid ${theme.branding.tertiary.main}` : 'none'};

  .MuiOutlinedInput-multiline {
    background-color: #f5f6f8;
  }
`;

export const ErrorText = styled.p`
  color: ${({ theme }) => theme.branding.tertiary.main};
  margin: 0;
`;

export const FormField = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .MuiFormControlLabel-root {
    margin-left: 0;
  }

  label {
    cursor: pointer;
  }
`;

export const ToastStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;

  h4 {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    font-weight: 600;
  }

  span {
    text-transform: uppercase;
    font-weight: bold;
  }
`;

export const FieldsWrapper = styled.div`
  width: 100%;
  padding-top: 5px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-height: 90px;

  h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  line-height: 20px;
  font-size: 14px;
  color: #323338;
  margin-right: 20px;

  .title {
    flex-shrink: 0;
    width: 155px;
  }

  .value {
    flex-grow: 1;

    .MuiSkeleton-root {
      max-width: 280px;
    }
  }

  .title-bold {
    font-weight: bold;
    margin-bottom: 5px;
  }
`;

export const InfoWrapper = styled.div<{success?: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 340px;

  .MuiSvgIcon-root {
    color: ${({theme, success}) => success ? theme.branding.primary.main : 'rgba(0, 0, 0, 0.54)'}
  }
`;
